var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vue-select2" }, [
    _c("select", {
      ref: "select",
      class: { textCenter: _vm.isCentered },
      style: { minWidth: _vm.width }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }